/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Leads from './Leads/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Lead/Content"
  
}) {
  return (<React.Fragment
>
<Leads
  viewPath={`${viewPath}/Leads`}
/>
{children}
</React.Fragment>)
}